module.exports = __webpack_public_path__ + "static/media/-_Welfare.7eb2e522.png";